export const SESSION_USER_PARAMETERS_CONSTANT = "_grandus_user_session_parameters";

export const USER_VAT_PRICES_PARAMETER_HASH = 'USER_VAT_PRICES';
